"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreflightAnomaly = exports.PreflightAnomalySeverity = void 0;
const zod_1 = require("zod");
exports.PreflightAnomalySeverity = zod_1.z.enum(["INFO", "WARNING", "ERROR"]);
const PreflightAnomalyCode = zod_1.z.enum([
    "UNSUPPORTED_ANOMALY",
    "DRC_GENERIC",
    "DRC_EMPTY_PLANE",
    "DRC_OVERLAPPING_PINS_DIFFERENT_NETS",
    "ROUTING_UNROUTABLE_PIN",
    "ROUTING_UNROUTABLE_DIFFERENTIAL_PAIR_PINS",
    "ROUTING_PIN_INSIDE_KEEPOUT",
    "ROUTING_GENERIC",
    "ROUTING_NOTHING_TO_ROUTE",
    "ROUTING_PIN_OUTSIDE_BOUNDARY",
    "ROUTING_PIN_PARTIALLY_OUTSIDE_BOUNDARY",
    "ROUTING_OVERLAPPING_PINS_SAME_NET",
    "ROUTING_JUMPER_DETECTED",
    "ROUTING_UNTWINNABLE_DIFFERENTIAL_PAIR",
    "PLACEMENT_GENERIC",
    "BOARD_DEFINITION_GENERIC",
]);
const PreflightAnomalyBase = zod_1.z.object({
    code: PreflightAnomalyCode,
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    message: zod_1.z.string(),
    severity: exports.PreflightAnomalySeverity,
    // This value is populated by us when we encounter an anomaly that we don't know how to handle.
    originalCode: zod_1.z.string().optional(),
});
const PreflightAnomalyStrict = zod_1.z.discriminatedUnion("code", [
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.DRC_OVERLAPPING_PINS_DIFFERENT_NETS),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinIds: zod_1.z.array(zod_1.z.string()),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_UNROUTABLE_PIN),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinId: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_UNROUTABLE_DIFFERENTIAL_PAIR_PINS),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinIds: zod_1.z.array(zod_1.z.string()),
        }),
    }),
    // Note: The anomalies below are currently unsupported, and not shown in the UI, thus the data object is any
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_GENERIC),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.DRC_GENERIC),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.PLACEMENT_GENERIC),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.BOARD_DEFINITION_GENERIC),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_PIN_INSIDE_KEEPOUT),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinId: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_NOTHING_TO_ROUTE),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.ERROR),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_PIN_OUTSIDE_BOUNDARY),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinId: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_PIN_PARTIALLY_OUTSIDE_BOUNDARY),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinId: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_OVERLAPPING_PINS_SAME_NET),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            pinIds: zod_1.z.array(zod_1.z.string()),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_JUMPER_DETECTED),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            componentDefinitionId: zod_1.z.string(),
            pinDefinitionId: zod_1.z.string(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.ROUTING_UNTWINNABLE_DIFFERENTIAL_PAIR),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.WARNING),
        data: zod_1.z.object({
            netIds: zod_1.z.array(zod_1.z.string()),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.DRC_EMPTY_PLANE),
        severity: zod_1.z.literal(exports.PreflightAnomalySeverity.enum.INFO),
        data: zod_1.z.object({
            netId: zod_1.z.string(),
            layer: zod_1.z.number(),
        }),
    }),
    zod_1.z.object({
        ...PreflightAnomalyBase.shape,
        code: zod_1.z.literal(PreflightAnomalyCode.enum.UNSUPPORTED_ANOMALY),
        originalCode: zod_1.z.string(),
    }),
]);
exports.PreflightAnomaly = PreflightAnomalyStrict.catch((ctx) => ({
    ...ctx.input,
    code: PreflightAnomalyCode.enum.UNSUPPORTED_ANOMALY,
    originalCode: ctx.input.code,
}));
//# sourceMappingURL=anomalies.js.map